import { Component, Input, OnInit } from '@angular/core';

@Component({
  selector: 'mwo-action-button',
  templateUrl: './action-button.component.html',
  styleUrls: ['./action-button.component.scss']
})
export class ActionButtonComponent implements OnInit {
  @Input() icon: string;
  @Input() alt: string;
  @Input() translationKey = '';
  @Input() mode: string;
  @Input() isShuffled: boolean;
  @Input() isPlaying: boolean;
  @Input() isActive: boolean;

  constructor() { }

  ngOnInit() { }
}
